<template>
   <div :class="col">
      <div class="mb-0 position-relative sa-field">
         <!-- Label above the box (main.js formStyle 'icons' and 'plain') -->
         <label v-if="label && !floating" class="form-label">{{ label }}</label>

         <div :class="wrapClass" @focusin="focused = true" @focusout="focused = false">
            <!-- Icon in front (formStyle 'icons' only) -->
            <span v-if="showIcon" class="input-group-text"><i :class="icon"></i></span>

            <TagSelect
               v-bind="$attrs"
               :model-value="modelValue"
               :placeholder="floating ? ' ' : placeholder"
               class="multiSelect-validation-field custom-tooltip-input"
               :class="{ 'flex-grow-1': showIcon }"
               @update:modelValue="$emit('update:modelValue', $event)"
            />

            <!-- Floating label: inside the box, moves up onto the border (formStyle 'floating') -->
            <label v-if="floating" class="sa-float-label">{{ label }}</label>
         </div>

         <!-- Grey note under the box, e.g. "Type to search the tags." -->
         <small v-if="hint" class="text-muted d-block sa-core-color">{{ hint }}</small>

         <!-- Above the box on focus -->
         <div v-if="tooltip" class="custom-tooltip">{{ tooltip }}<span class="tooltip-arrow"></span></div>
      </div>
   </div>
</template>

<script>
// The Tags box (TagSelect) with the same looks as FormField (main.js formStyle).
//   <TagField v-model="formInputs.tags" col="col-12" label="Tags" icon="fa fa-tags"
//             :tags="tagOptions" :api="tagsEndpoint" :allow-create="..." @created="tag => tagOptions.push(tag)" />
// tags, api, allow-create and @created go straight to TagSelect.
import TagSelect from "./TagSelect.vue";

export default {
   name: "TagField",
   components: { TagSelect },
   inheritAttrs: false,
   props: {
      modelValue: { type: Array, default: () => [] },
      label: { type: String, default: "" },
      icon: { type: String, default: "" },
      placeholder: { type: String, default: "" }, // empty = TagSelect's own text
      tooltip: { type: String, default: "" },
      hint: { type: String, default: "" },
      col: { type: String, default: "col-12" },
   },
   emits: ["update:modelValue"],
   data() {
      return { focused: false };
   },
   computed: {
      formStyle() {
         return this.$formStyle || "icons";
      },
      floating() {
         return this.formStyle === "floating" && !!this.label;
      },
      showIcon() {
         return this.formStyle === "icons" && !!this.icon;
      },
      wrapClass() {
         if (this.showIcon) return "input-group";
         if (this.floating) {
            return {
               "sa-float": true,
               "is-up": this.focused || (this.modelValue || []).length > 0,
               "is-focused": this.focused,
            };
         }
         return "";
      },
   },
};
</script>